//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-229241 - Remove feature flag usage once Harmony AI Creators Integration is fully released
export const getHasHarmonyAiCreatorsIntegrationFeatureEnabled =
  createHasFeatureSelector(FeatureNames.HarmonyAiCreatorsIntegration);

// TODO: PD-249047 - Remove feature flag usage once Influenster Pro is fully released
export const getHasHarmonyAiInfluensterProStatusEnabled =
  createHasFeatureSelector(FeatureNames.InfluensterProStatus);
